export const getDateNow = () => {
  const now = Date.now();

  return Number.isFinite(now) ? now : new Date().getTime();
};
